export default __webpack_public_path__ + "static/media/logo.406b4347.png";